import { useTranslation } from 'react-i18next';

import { PalletsStackIcon } from 'assets';
import { NoItemsNotification, StyledTable } from 'components/shared';
import { useTableHeaders } from 'constants/tableHeaders';
import { PalletReport } from 'interfaces';

import DamagedLostPalletsTableItem from './DamagedLostPalletsTableItem/DamagedLostPalletsTableItem';

type DamagedLostPalletsTableProps = {
   palletReports: PalletReport[];
   isDamagedLostBySupplier?: boolean;
};

const DamagedLostPalletsTable = ({
   palletReports,
   isDamagedLostBySupplier,
}: DamagedLostPalletsTableProps) => {
   const { t } = useTranslation();

   const {
      damagedDestroyedLostPalletsByClientTableHeaders,
      lostDamagedPalletsInDeliveryClientTableHeaders,
   } = useTableHeaders();

   return (
      <StyledTable
         columnHeaders={
            isDamagedLostBySupplier
               ? lostDamagedPalletsInDeliveryClientTableHeaders
               : damagedDestroyedLostPalletsByClientTableHeaders
         }
      >
         {palletReports.length ? (
            palletReports.map(palletReport => (
               <DamagedLostPalletsTableItem key={palletReport.id} palletReport={palletReport} />
            ))
         ) : (
            <tr>
               <td colSpan={isDamagedLostBySupplier ? 6 : 4}>
                  <NoItemsNotification
                     icon={<PalletsStackIcon />}
                     description={t('damagedLostPalletsTable.noReports')}
                  />
               </td>
            </tr>
         )}
      </StyledTable>
   );
};

export default DamagedLostPalletsTable;
